import React from "react"
import { ShopperInsightsSearchHitCheckout } from "lib/types/generated/graphql-types"
import Money from "components/Money"
import DineroFactory from "dinero.js"
import { SmallInfo } from "./CustomerOrderTable.styled"
import {
  OrderLineRow as StyledOrderLineRow,
  ProductInfo,
  ProductName,
  QuantityCell,
  UnitPriceCell,
  DiscountedBasePrice,
  SalePrice,
  RegularPrice,
  TotalCell
} from "./CustomerCheckoutSessionTable.styled"

type Props = {
  item: ShopperInsightsSearchHitCheckout['items'][0]
  currencyCode: string
}

const OrderLineRow = ({ item, currencyCode }: Props) => {
  const hasDiscount = (item.basePriceAmount || 0) > (item.salePriceAmount || 0)

  return (
    <StyledOrderLineRow>
      <ProductInfo>
        <ProductName>{item.displayName}</ProductName>
        {item.productVariantId && (
          <SmallInfo>Variant ID: {item.productVariantId}</SmallInfo>
        )}
      </ProductInfo>
      <QuantityCell>
        {item.quantity}
      </QuantityCell>
      <UnitPriceCell>
        {hasDiscount ? (
          <>
            <DiscountedBasePrice>
              <Money 
                amount={item.basePriceAmount || 0} 
                currencyUnit={currencyCode as DineroFactory.Currency} 
              />
            </DiscountedBasePrice>
            <SalePrice>
              <Money 
                amount={item.salePriceAmount || 0} 
                currencyUnit={currencyCode as DineroFactory.Currency} 
              />
            </SalePrice>
          </>
        ) : (
          <RegularPrice>
            <Money 
              amount={item.salePriceAmount || item.basePriceAmount || 0} 
              currencyUnit={currencyCode as DineroFactory.Currency} 
            />
          </RegularPrice>
        )}
      </UnitPriceCell>
      <TotalCell>
        <Money 
          amount={item.totalPriceAmount || 0} 
          currencyUnit={currencyCode as DineroFactory.Currency} 
        />
      </TotalCell>
      <div></div>
    </StyledOrderLineRow>
  )
}

export default OrderLineRow